__turbopack_context__.v({
  "card": "KibbePreparation-module__lP3hjW__card",
  "form": "KibbePreparation-module__lP3hjW__form",
  "grid": "KibbePreparation-module__lP3hjW__grid",
  "heading": "KibbePreparation-module__lP3hjW__heading",
  "intro": "KibbePreparation-module__lP3hjW__intro",
  "progress": "KibbePreparation-module__lP3hjW__progress",
  "submit": "KibbePreparation-module__lP3hjW__submit",
});
